import React, { Component } from 'react';
import logo from './title.jpeg';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
        </header>
        <p className="App-intro">
            七加二科技是一家精品软件公司，由几位知名创业者、技术大神、福布斯杰出青年在2019年共同创办。七加二科技服务高端用户群体，为用户提高工作效率，增强使用体验，从而创造更多社会价值。
        </p>
        <footer className="App-footer">
            <a href="http://beian.miit.gov.cn/" target="_blank">沪ICP备20004978号-2</a>
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js